import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      {items.map((item, i) => (
        <span key={`${item.label}-${i}`} className="flex items-center gap-1">
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-500 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
        </span>
      ))}
    </nav>
  );
}